<template>
  <div>
    <span style="visibility: hidden">
      -----------------------------------------------------------------------------------------------------------
    </span>
    <v-treeview
      :items="legenda"
      dense
      open-on-click
    >
      <template v-slot:label="{ item }">
        <span
          v-if="item.root"
          class="font-weight-bold caption"
          width="300"
        >{{
          item.nome
        }}</span>
        <span
          v-else
          class="caption"
        >
          <span
            class="font-weight-bold"
            :style="`color: ${item.color}`"
          >{{ item.descricao }}: </span>{{ item.descricaoAcao }}
        </span>
      </template>
    </v-treeview>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  computed: {
    ...mapState({
      tiposDificuldade: (state) => state.desempenho.tiposDificuldade,
    }),

    legenda() {
      return [
        {
          root: true,
          nome: 'Legenda Dificuldade:',
          children: this.tiposDificuldade,
        },
      ];
    },
  },
};
</script>
